import { TOAST } from "@commoncore/constants/ToastMessages";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS } from "properties/environment";
import { GlobalClassInstance } from "../constants/GlobalClass";
import { CustomSortService } from "../services/custom-sort.service";
import { JustifiedView } from "../utils/JustifiedViewUtil";
import { MultiSelectLibrary } from "../utils/MultiSelectUtil";
import { PreviewImplementation } from "./PreviewImplementation";

export class PeoplesTabImplementation {

    public http : any;
    public globalService : any;
    public universalService: any;
    public peopleService:any;
    static singleInstance:any = null;
    public detectedFaces:any = [];
    public peopleNextLink:any="";
    public peoplePreviousLink:any="";
    customMetadata:any;
    multiSelect:any;
    JsView:any;
    customSort:any;
    dateSort:boolean = false;
    localStorageService:any;
    sortType:any="";
    isServerError:boolean = false;
    listService:any;
    loader:boolean = false;
    previewImplementation: any;
    containerHeightCalc:any;
    public recommendationData:any = [];   
    mergeRetryCount:number = 0;
    activeDimensions:any ={
      'activeHeight': 300,
      'activeWidth' : 300
    }; 
    activeDimensionsSmallMobile:any ={
      'activeHeight': 250,
      'activeWidth' : 250
    }; 
    private displayFactor = 2;
    public detectedFacesListForSuggestion:any = [];
    showSuggestionConfirmationModal:boolean = false;
    showSuggestionAvailableModal:boolean = false;
    showThankYouModal:boolean = false;
    maxSuggestionsToShow:number = 5;
    cleverTapEventsService:any;
    public currentPageNo = 0;
    public previousPageNo = -1;
    paginationService: any;
    
    searchService:any;
    isAnimateFeaturePhoto:boolean = false;
    hasVideoGlobally: boolean = false;
    constructor(globalService){
        this.globalService=globalService;
    }

    public setHandler(globalService) {
        this.http = globalService.getHttpClientRef();
        this.universalService = globalService.getUniversalServiceRef();
        this.customMetadata = globalService.getCustomMetadataServiceRef();
        this.multiSelect = MultiSelectLibrary.getInstance(globalService);
        this.JsView = new JustifiedView(this.universalService);
        this.customSort = new CustomSortService(this.universalService);
        this.localStorageService = globalService.getLocalStorageSvcRef();
        this.listService = globalService.getListServiceRef();
        this.previewImplementation = PreviewImplementation.getInstance(globalService);
        this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
        this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
        this.paginationService = globalService.getPaginationServiceRef();
        this.searchService = globalService.getSearchServiceRef();
        this.peopleService = globalService.getPeopleServiceRef();
    }

    public static getInstance(globalService):PeoplesTabImplementation{
        if(this.singleInstance == null){
          this.singleInstance = new PeoplesTabImplementation(globalService);
          return this.singleInstance;
        }else{
          return this.singleInstance;
        }
      }

    getAllDetectedPeoplesFaces(url){
        var self = this;
        this.peopleNextLink = "";
        this.peoplePreviousLink = "";
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                resp=>{
                    self.resetDataBeforeSettingRequiredView();
                    self.paginationService.spliceAndSaveDataInLocalDB(resp["faces"]);
                    self.fetchNextAndPreviousLinksForPagination(resp);
                    self.checkFGPStatus(resp)
                    self.setRequiredView(self.paginationService.getBufferDataForNextPage(self.currentPageNo));
                    self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                    self.universalService.showLoader = false;
                    self.loader = false;
                    resolve(resp);
                },
                err=>{
                    self.universalService.showLoader = false;
                    self.loader = false;
                    self.isServerError = true;
                    self.setContainerHeight();
                    reject(err);
                }
            )
        })
    }

    bindMultiSelect(){
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.multiSelect.bindMultiSelectLibrary("#peopleDetailsWrapper", "grid_info", ".fileThumbnail:visible", true,this.universalService.virtualGridEnabled,false);
      this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
      AppEvents.multiSelectEvent.next({"dataArray":this.detectedFaces})
    }

    getAllPhotosOfSelectedPerson(url){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.resetDataBeforeSettingRequiredView();
                let type = self.universalService.checkIfImgTypeParamIsRequired("");
                let faceThumbnailUrl = resp["metadata"]["face_thumbnail_url"].includes("?") ? resp["metadata"]["face_thumbnail_url"] + "&" : resp["metadata"]["face_thumbnail_url"] + "?";
                resp["metadata"]["face_thumbnail_url"] = faceThumbnailUrl + 'size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
                self.paginationService.spliceAndSaveDataInLocalDB(resp["metadata"]["objects"]);
                self.fetchNextAndPreviousLinksForPagination(resp);
                self.checkFGPStatus(resp);
                self.setRequiredView(self.paginationService.getBufferDataForNextPage(self.currentPageNo));
                self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                resolve(resp);
            },
            err=>{
                self.universalService.showLoader = false;
                self.loader = false;
                self.isServerError = true;
                self.setContainerHeight();
                reject(err);
            }
        )
      })
    }

    resetDataBeforeSettingRequiredView(){
      this.currentPageNo = 0;
      this.previousPageNo = -1;
      this.paginationService.LOCAL_DB = {}
      this.detectedFaces = [];
      if(this.sortType.includes("fileCreatedDate") && (this.universalService.currentTab == 'Person Details' || this.universalService.currentTab == 'Place Details')){
        this.dateSort = true;
      }else{
        this.dateSort = false;
      }
    }


    checkFGPStatus(resp){
      let objects = resp["faces"] ? resp["faces"] : resp["metadata"]["objects"]
      let  fgpStatus = resp.fgp_processing_status?resp.fgp_processing_status:"";
      this.universalService.selectedFace = resp;
      if( fgpStatus == "WIP" && objects.length > 0 && resp._links.prev == undefined){
        this.universalService.showToast(TOAST["FGP_INPROCESS"],'success');
      }
    }
    checkPalcesStatus(resp){
      // let objects = resp["faces"] ? resp["faces"] : resp["metadata"]["objects"]
      // let  fgpStatus = resp.fgp_processing_status?resp.fgp_processing_status:"";
      this.universalService.selectedFace = resp;
      // if( fgpStatus == "WIP" && objects.length > 0 && resp._links.prev == undefined){
      //   this.universalService.showToast(TOAST["FGP_INPROCESS"],'success');
      // }
    }

    async setRequiredView(faces){
      this.isServerError = false;

      var faceList = this.setCustomMetadataForPeopleFaces(faces);
      await this.checkIfJustifiedLayout(faces);
      if(this.universalService.currentTab == "Place Details"){
        var imageList = this.customMetadata.segregateData(faceList, "allfiles");
      }else{
        var imageList = this.customMetadata.segregateData(faceList, "photos");
      }
      var array = [];
      if(this.dateSort){
        array = this.customSort.sortByDates(imageList,this.detectedFaces , [],"createdDate");
        this.detectedFaces = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.universalService.showLoader = false;
        this.loader = false;
      }else{
        array = this.customSort.createSortedObjectFormatsForAccessing(imageList, this.detectedFaces);
        this.detectedFaces = array[0];
        this.universalService.objectsPreviewArray = array[1];
        this.universalService.showLoader = false;
        this.loader = false;
      }
      // this.detectedFaces.forEach(obj => {
      //   let type = this.universalService.checkIfImgTypeParamIsRequired(obj["mimeSubType"]);
      //   console.log("GIF"+obj["mimeSubType"]+">>>>"+type)
      //   obj["imageTranscodeUrl"] = obj["imageTranscodeUrl"] + '&appSecret=' + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-App-Secret"]+type;
      // });
      if(this.universalService.currentTab == "Person Details" || this.universalService.currentTab == "Place Details"){
        if(this.universalService.currentTab == "Place Details"){
          if(this.universalService.showJustifiedLayout){
            this.generateJustifiedView(this.detectedFaces)
          }else{
            // this.bindMultiSelect();
            AppEvents.virtualDOMObservable.next({"updateVDOM":true})
            this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
            this.multiSelect.bindMultiSelectLibrary("#peopleDetailsWrapper", "grid_info", ".gridItem:visible", true,this.universalService.virtualGridEnabled,false);
            this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");
            AppEvents.multiSelectEvent.next({"dataArray":this.detectedFaces})
          }
        }else{
          this.generateJustifiedView(this.detectedFaces)
        }
      }else{
         this.detectedFaces = array[1];
         //If People tab, set data in cache
         var clonedData = this.detectedFaces.slice();//clone to avoid data to be referenced 
         this.peopleService.setPeopleData(clonedData);
         var clonedNextLink = this.peopleNextLink.slice();//cloned next link when uer directly gets 2nd page data and scrolls
         this.peopleService.setNextLinkData(clonedNextLink);
      }
      this.setContainerHeight();
      if(this.universalService.currentTab == "Person Details" || this.universalService.currentTab == "Palces Details"){
        if(this.detectedFaces.length>0){
          this.universalService.emptyTab = false;
        }else{
          this.universalService.emptyTab = true;
        }
      }

      setTimeout(() => {
        AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      }, 10);
    }
    checkIfJustifiedLayout(faces){
      const data = faces.flatMap(month => month["objects"] || month);
      const pageHasVideo = data.some(obj => obj.mimeType === 'video');
      if (pageHasVideo) {
        this.hasVideoGlobally = true;
      }
      this.universalService.showJustifiedLayout = !this.hasVideoGlobally;
    }
    async generateJustifiedView(objects){
      if(this.detectedFaces && this.detectedFaces?.length > 0) {
        this.detectedFaces.map((object,indexOfMonth)=>{ // If we get any option as "null", setting as null, in generateJustifiedView(), it is handled
          object["objects"].map((obj)=>{
            if(obj.width == "null") obj.width = null;
            if(obj.height == "null") obj.height = null;
          })
          })  
      } 
      var justifiedView = await this.JsView.generateJustifiedView(this.detectedFaces, "#peopleDetailsWrapper", this.universalService.rowHeightTolerance);
      this.detectedFaces = justifiedView;
      this.bindMultiSelect();
    }

    updateFaceName(url,faceName){
        var self = this;
        var payload = {
            "face_name": faceName
        }
        return new Promise(function(resolve,reject){
        self.http.put(url,payload).subscribe(
            suc=>{
                resolve(suc);
            },
            err=>{
                console.log("faceName set error",err);
                reject(err);
            }
        )
        })
    }

    fetchNextAndPreviousLinksForPagination(resp){
        var linksData = resp["_links"]?resp["_links"]:resp["links"]
        if (linksData && linksData["next"]) {
            this.peopleNextLink = linksData["next"];
        } else {
            this.peopleNextLink = ""
        }

          
    }

    async createUrlForNextLink(docheignt, toppos, url) {
        if (toppos == 0) {
          setTimeout(() => {
            this.universalService.scrollToTopIcon = false;
          }, 10);
          this.isAnimateFeaturePhoto = false;
        } else {
          this.isAnimateFeaturePhoto = true;
          this.universalService.scrollToTopIcon = true;
          let checkIfContaineris95PercScrolled = this.universalService.virtualGridEnabled ? true : (toppos + $(".scrollableContainer").innerHeight()) >= (0.95 * docheignt)
          if(checkIfContaineris95PercScrolled && this.previousPageNo != this.currentPageNo && this.paginationService.LOCAL_DB[this.currentPageNo + 1] && this.paginationService.LOCAL_DB[this.currentPageNo + 1].length != 0){
            this.previousPageNo = this.currentPageNo;
            setTimeout(async () => { // timeout is added to restrict fetching data for multiple pages back to back as the scroll event is fired multiple times
              this.currentPageNo ++;
              let objList = await this.paginationService.getBufferDataForNextPage(this.currentPageNo);
              await this.appendData(objList);
              this.paginationService.deleteLocalBufferOnceThePageIsViewed(this.currentPageNo)
            }, this.paginationService.bufferTimeoutForFetchingData);
          }
          if ( checkIfContaineris95PercScrolled && this.peopleNextLink!= ""  && this.peoplePreviousLink != this.peopleNextLink){       
            this.universalService.showLoader = true;
            this.universalService.loader = true;
            this.peoplePreviousLink = this.peopleNextLink;
            if(this.universalService.currentTab == "Person Details" || this.universalService.currentTab == "Place Details"){
              url = url + "&sort=" + this.sortType;
            }
            this.getNextPageData(url)
          }
        }
    }

    setCustomMetadataForPeopleFaces(faces){
      // face_download_url and face_thumbnail_url are being returned for /people responses
      // image_download_url and image_thumbnail_url are being returned for cluster of person photos
        faces.map(face=>{
          if(this.universalService.currentTab == "Place Details") {
            face["url"] = face["downloadURL"];
            face["imageTranscodeUrl"] = face["thumbnailURL"];
            face["objectType"] = "FE";
            face["mimeType"] =  face["mimeType"];
            face["objectKey"] = face["objectKey"];
            face["objectName"] = face["objectName"]? face["objectName"] : ((face["face_name"] == null || !face["face_name"])?"":face["face_name"]);
            face["createdDate"] = face["createdDate"];
            face["displayName"] = face["mimeType"]
            face["fileCreatedDate"] = face["fileCreatedDate"]?face["fileCreatedDate"]:face["createdDate"]
          }else if(this.universalService.currentTab == "Places"){
            face["url"] = face["downloadURL"];
            face["imageTranscodeUrl"] = face["placeCoverPicURL"];
            face["objectType"] = "FE";
            face["mimeType"] = "image";
            face["objectKey"] = face["objectKey"];
            face["objectName"] = face["objectName"]? face["objectName"] : ((face["face_name"] == null || !face["face_name"])?"":face["face_name"]);
            face["createdDate"] = face["createdDate"];
            face["displayName"] = "Image"
            face["fileCreatedDate"] = face["fileCreatedDate"]?face["fileCreatedDate"]:face["createdDate"]
          }else{
            face["url"] = face["face_download_url"]?face["face_download_url"]:face["image_download_url"];
            face["imageTranscodeUrl"] = face["face_thumbnail_url"]?face["face_thumbnail_url"]:face["image_thumbnail_url"];
            face["objectType"] = "FE";
            face["mimeType"] = "image";
            face["objectKey"] = face["face_key"]?face["face_key"]:face["object_key"];
            face["objectName"] = face["objectName"]? face["objectName"] : ((face["face_name"] == null || !face["face_name"])?"":face["face_name"]);
            face["createdDate"] = face["createdDate"];
            face["displayName"] = "Image"
            face["fileCreatedDate"] = face["fileCreatedDate"]?face["fileCreatedDate"]:face["createdDate"]
          }
        })
        return faces;
    }

    getNextPageData(url) {
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
          async nextPageData => {
            // self.appendData(nextPageData);
            if(self.universalService.currentTab == 'Person Details'){
              let type = self.universalService.checkIfImgTypeParamIsRequired("");
              nextPageData["metadata"]["face_thumbnail_url"] = nextPageData["metadata"]["face_thumbnail_url"] + '?size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
            }
            let objects = [];
            if (self.universalService.currentTab == "Place Details") {
              self.universalService.checkIfImgTypeParamIsRequired("");
              self.checkPalcesStatus(nextPageData);
              objects = nextPageData["objects"] || [];
            } else {
              self.checkFGPStatus(nextPageData);
              objects = nextPageData["faces"] ? nextPageData["faces"] : nextPageData["metadata"]["objects"];
            }
            let type = self.universalService.checkIfImgTypeParamIsRequired("");
            self.checkPalcesStatus(nextPageData);
            if(nextPageData["objects"] && !self.paginationService.LOCAL_DB[self.currentPageNo]){ // this condition is added when user has scrolled all the buffer data, there is no buffer data left and API call is taking time or due to network latency to return data, post API response we are populating the data
              let bufferDataPresent = self.paginationService.checkIfBufferDataIsPresent();
              if(!bufferDataPresent){
                self.currentPageNo = Object.keys(self.paginationService.LOCAL_DB).length;
                self.previousPageNo = self.currentPageNo - 1;
                self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
                self.fetchNextAndPreviousLinksForPagination(nextPageData);
                let objList = await self.paginationService.getBufferDataForNextPage(self.currentPageNo);
                await self.appendData(objList);
                self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo);
                resolve({"resp":nextPageData});
                return;
              }
            }
            self.universalService.showLoader = false;
            self.paginationService.spliceAndSaveDataInLocalDB(nextPageData["objects"]);
            self.fetchNextAndPreviousLinksForPagination(nextPageData);
            resolve({"resp":nextPageData});
            
          },
          err => {
            self.universalService.showErrorMessage(err);
          }
        )
      })
    }

    /*setCustomHeightAndWidth(){
      var fullWidth = $('.custom-image-thumb-gallery').innerWidth();
      var noOfThumbnailsToFit = Math.floor(fullWidth/212);
      var noOfSpaces = noOfThumbnailsToFit + 1 ;
      var marginPx = (fullWidth - (noOfThumbnailsToFit * 212))/noOfSpaces;
      var marginPx = 8;//noOfThumbnailsToFit + 5;
      var containerMargin = "-" + marginPx + "px";
      $('.custom-thumb-img-holder').css({'height':"280px",'width':"212px",'margin':marginPx+"px"});
      const $elem = $('.custom-image-thumb-gallery');
      if($elem[0]){ 
        $elem[0].style.setProperty('margin-left', containerMargin , 'important');
      }
    }*/
    
    //Based on no. of tiles to fit, calculating width and adjusted aspect ration of height
    setCustomHeightAndWidth(){
      var fullWidth = $('.custom-image-thumb-gallery').innerWidth();
      var noOfThumbnailsToFit = 8; // Tiles to show
      var marginPx = 4;
      fullWidth = (fullWidth - (noOfThumbnailsToFit * marginPx));
      var calcTileWidth = 0;
      var calcTileHeight = 0;
      calcTileWidth = (Math.floor(fullWidth/noOfThumbnailsToFit) - (marginPx * 2));
      calcTileHeight = Math.floor(calcTileWidth/0.75); //3:4 ratio
      $('.custom-thumb-img-holder').css({'height':calcTileHeight+"px",'width':calcTileWidth+"px",'margin':marginPx+"px"});
      $('.custom-default-thumbnail-icon').css({'height':calcTileHeight+"px",'width':calcTileWidth+"px"});
      
      const $elem = $('.custom-image-thumb-gallery');
      if($elem[0]){ 
        $elem[0].style.setProperty('margin-left', marginPx + 'px' , 'important');
        $elem[0].style.setProperty('display', 'flex');
      }
    }
    
    
    appendData(facesList) {
        this.setRequiredView(facesList);
        this.universalService.showLoader = false;
        this.loader = false;
        AppEvents.virtualDOMObservable.next({"updateVDOM":true})
        AppEvents.multiSelectEvent.next({"dataArray":this.detectedFaces})
        setTimeout(()=>{
          this.setCustomHeightAndWidth();
        },300)

    }

    enableFaceGroupingToggle(url){
      var self = this;
      var params = {
        "isFGPEnabled": this.universalService.isFaceGroupingToggle?"Y":"N"
      }
      return new Promise(function(resolve,reject){
        self.http.put(url,params).subscribe(
          suc=>{
            resolve(true)
          },
          err=>{
            console.log('error in toggling facegrouping',err);
            self.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
            reject(false);
          }
          )
      })
    }

    enableFaceGroupingFeature(url){
      var self = this;
      var params = {
        "user_status": "A"
      }
      return new Promise(function(resolve,reject){
        self.http.put(url,params).subscribe(
          suc=>{
            self.updateInLocalStorageAfterEnablingPeopleTab(suc);
            resolve({"fgpEnabled":true,state:"success"})
          },
          err=>{
            console.log('error in enabling facegrouping',err);
            reject({"fgpEnabled":false,state:err["error"]["code"]})
          }
          )
      })

    }

    updateInLocalStorageAfterEnablingPeopleTab(suc){
      var userData = this.localStorageService.getUserData(true);
      userData['isPplTabOn'] = "A";
      AppEvents.updateAuthData.next({updateAuthData:true,userData:userData});
      // AppEvents.updateUserStorage.next({updateUserStorage:true});
    }

    getRemoveOptionsList(url){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
          resp=>{
                self.universalService.showLoader = false;
                self.loader = false;
                resolve(resp["feedback"]);
          },
          err=>{
            self.universalService.showLoader = false;
            self.loader = false;
            console.log('error in fetching remove options list',err);
            reject(err)
          }
          )
      })
    }

    removeResults(url,params){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.put(url,params).subscribe(
          suc=>{
            if(self.universalService.showPreview){
              self.previewImplementation.removeResultsFromPreview();
            }
            self.removeObjectsFromUI(params["object_keys"]);
            self.cleverTapEventsService.userFaceResultRemoved();
            resolve(suc)
          },
          err=>{
            console.log('results removed err',err);
            reject(err)
          }
          )
      })
    }

    setAsCoverPhoto(url,params){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.post(url,params).subscribe(
          suc=>{
            self.setCoverPicOnThePeopleFace(suc);
            resolve(suc)
          },
          err=>{
            console.log('setAsCoverPhoto err',err);
            self.universalService.showToast(TOAST["PEOPLE_FACE_COVER_PIC_SET_FAILED"],"error");
            self.universalService.showLoader = false;
            reject(err)
          }
          )
      })
    }

    setCoverPicOnThePeopleFace(coverPicResponse){
      //set current people face cover pic
      let type = this.universalService.checkIfImgTypeParamIsRequired("");
      let coverPicUrl = coverPicResponse["face_thumbnail_url"].includes("?") ? coverPicResponse["face_thumbnail_url"] + "&" : coverPicResponse["face_thumbnail_url"] + "?";
      this.universalService.selectedFace["metadata"]["face_thumbnail_url"] = coverPicUrl + 'size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
      this.universalService.showToast(TOAST["PEOPLE_FACE_COVER_PIC_SET_SUCCESSFULLY"],"success");
      AppEvents.emit("FACE_GROUPING_GET_LATEST_FACES_SEARCH");
      
      //Update in search history
      var object = {
        "objectName": this.universalService.selectedFace["metadata"]["face_name"],
        "faceKey" : coverPicResponse["updated_face_key"],
        "format" : "face",
        "faceName" : this.universalService.selectedFace["metadata"]["face_name"],
        "imageTranscodeUrl" : this.universalService.selectedFace["metadata"]["face_thumbnail_url"],
      }
      var oldObject = {
        "faceKey" : this.universalService.selectedFace["metadata"]["face_key"],
      }
      this.searchService.updateFaceHistory(object, oldObject);
       //clear saved state when pic is updated
       this.clearPeopleTabDataInService();
    }

    removeObjectsFromUI(removedObjects){
      this.detectedFaces.map((month,indexOfMonth)=>{
        removedObjects.map(obj=>{
          var findRemoved = month["objects"].find(object=>object["objectKey"] == obj);
          if(findRemoved){
            var index = month["objects"].indexOf(findRemoved);
            if(index>=0){
              month["objects"].splice(index,1);
            }
          }
        })
        if(month["objects"].length == 0){
          this.detectedFaces.splice(indexOfMonth,1);
        }
      })
      if(this.detectedFaces.length == 0 && this.peopleNextLink.length>0){ // if all objects are selected and remove results
        this.getNextPageData(this.peopleNextLink)
      }
      this.listService.deSelectAll();
    }

    setContainerHeight(){
      var self = this;
      this.setHeight();
      $(window).resize(function () {
        setTimeout(()=>{
          self.setHeight();
        },1000)
      });
    }

    setHeight(){
      var self = this;
      setTimeout(() => {
        if (self.universalService.isMobileDevice) {
          self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.person-name-main','.pseudo-banner-container'],95)
          if(self.universalService.browserDetails.browser.name == "Safari"){
            document.body.addEventListener('touchmove', function(event) {
              event.preventDefault();
              let el = document.querySelector('.scrollableContainer')as any;
              el.style.padding = "5px 15px 30px 15px";
              self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-mobile-header','.person-name-main','.pseudo-banner-container'],61);
            });
          }
        }else{
          self.containerHeightCalc.calculateHeight('.scrollableContainer',['.heading-wrap','.pseudo-top-header','.person-name-main','.pseudo-banner-container','.empty-tabbed-view-selection-menu'],49)
        }
      },400);
    }

    updateDetectedFacesCountOnTheUI(array){
      AppEvents.virtualDOMObservable.next({"updateVDOM":true})
      AppEvents.multiSelectEvent.next({"dataArray":array});
      if(this.dateSort){
        var previewArray = [];
        array.map(month=>{
          previewArray = previewArray.concat(month["objects"])
        })
        this.universalService.objectsPreviewArray = previewArray;
      }else{
        this.universalService.objectsPreviewArray = array["objects"];
      }

    }

    clearPreviewCache(){
      this.previewImplementation.cachedImgPreviewDataArray = [];
    }
    //Get face recommendations() {
    getFacesRecommendations(url) {
      var self = this;
      this.recommendationData = [];
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
              resp=>{
                self.universalService.showLoader = false;
                self.loader = false;
                self.setRecommendationDataset(resp);
                resolve(resp);
              },
              err=>{
                self.universalService.showLoader = false;
                self.loader = false;
                //self.isServerError = true;
                self.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
                reject(err);
              }
          )
      })
    }

    setRecommendationDataset(faces) {
      var self = this;
         
      if(faces["parents"]) {
        faces["parents"].map(async face=>{
          let type = self.universalService.checkIfImgTypeParamIsRequired("");
          let faceThumbnailUrl = face["face_thumbnail_url"].includes("?") ? face["face_thumbnail_url"] + "&" : face["face_thumbnail_url"] + "?";
          face["face_thumbnail_url"] = faceThumbnailUrl + 'size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
          face["height"] =  face["metadata"]["height"];
          face["width"] =  face["metadata"]["width"];
          face["metadata"]["image_thumbnail_url"] = await this.getImageSize(face);
        })
      }
      if(faces["object_pairs"] && faces["object_pairs"].length > this.maxSuggestionsToShow) {
        faces["object_pairs"] = faces["object_pairs"].slice(0, this.maxSuggestionsToShow);
      }
      if(faces["object_pairs"]) {
        faces["object_pairs"].map(async face=>{
          let type = self.universalService.checkIfImgTypeParamIsRequired("");
          let faceThumbnailUrl = face["face_thumbnail_url"].includes("?") ? face["face_thumbnail_url"] + "&" : face["face_thumbnail_url"] + "?";
          face["face_thumbnail_url"] = faceThumbnailUrl + 'size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
          face["height"] =  face["metadata"]["height"];
          face["width"] =  face["metadata"]["width"];
          face["metadata"]["image_thumbnail_url"] = await this.getImageSize(face);
          
        })
      }
      this.recommendationData = faces;
    }

    mergeRecommendation(url,suggestionData){
      var self = this;
      var payload = {
        "suggestions" : suggestionData
      }
      return new Promise(function(resolve,reject){
      self.http.post(url, payload).subscribe(
          suc=>{
              resolve(suc);
          },
          err=>{
              console.log("suggestion merge error..",err);
              self.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
              self.universalService.showLoader = false;
              reject(err);
          }
      )
      })
  }

  //Get all faces on Thank you modal - using different method as existing one changes photos of details as same variable data gets set
  getAllPeoplesFacesForSuggestion(url){
    var self = this;
    this.peopleNextLink = "";
    this.peoplePreviousLink = "";
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.setRequiredDataForSuggestionFaces(resp);
                self.universalService.showLoader = false;
                self.loader = false;
                resolve(resp);
            },
            err=>{
                self.universalService.showLoader = false;
                self.loader = false;
                self.isServerError = true;
                self.setContainerHeight();
                reject(err);
            }
        )
    })
  }
  async setRequiredDataForSuggestionFaces(resp) {
    var self = this;
    this.detectedFacesListForSuggestion = resp["faces"]?resp["faces"]:resp["metadata"]["objects"];
    //Remove face suggestion of selected/shown face
    this.detectedFacesListForSuggestion = this.detectedFacesListForSuggestion.filter((face)=>{
      return face.face_key != self.universalService.selectedFace.metadata.face_key;
    })
    
    this.detectedFacesListForSuggestion.map(face=>{
      let type = self.universalService.checkIfImgTypeParamIsRequired("");
      let faceThumbnailUrl = face["face_thumbnail_url"].includes("?") ? face["face_thumbnail_url"] + "&" : face["face_thumbnail_url"] + "?";
      face["face_thumbnail_url"] = faceThumbnailUrl + 'size=c&apiKey='+ ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    });
    if(this.detectedFacesListForSuggestion.length == 0) {
      $(".more-suggestion-grid-cont").css("display", "none");
    }
  }

  getImageSize(file) {
    if (this.universalService.isMobileDevice) { //it will be mobile device
      if ((file["height"] == undefined || file["width"] == undefined)) {
        var img = new Image();
        var size = 'n';
        var previewTranscodeUrl = file["previewTranscodeUrl"];
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        previewTranscodeUrl = previewTranscodeUrl.indexOf('?') >= 0 ? previewTranscodeUrl + "&" : previewTranscodeUrl + "?";
        previewTranscodeUrl = previewTranscodeUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = previewTranscodeUrl;
        img.onload = (event) => {
          file["height"] = img.height;
          file["width"] = img.width;
          var imageDim = this.setPositionForImage(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };
          file["metadata"]["imageHeight"] = imageDim.imageHeight;
          file["metadata"]["imageWidth"] = imageDim.imageWidth;
          var webUrl = this.getImageUrl(dimensions, file);
          file["metadata"]["suggestionPreviewUrl"] = webUrl;
        };
      } else {
        imageDim = this.setPositionForImage(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        file["metadata"]["imageHeight"] = imageDim.imageHeight;
        file["metadata"]["imageWidth"] = imageDim.imageWidth;
        var webUrl = this.getImageUrl(dimensions, file);
        file["metadata"]["suggestionPreviewUrl"] = webUrl;
      } 
    }else {
      if ((file["height"] == undefined || file["width"] == undefined)) {
        var img = new Image();

        var size = 'f';
        var previewTranscodeUrl = file["previewTranscodeUrl"];
        let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
        previewTranscodeUrl = previewTranscodeUrl.indexOf('?') >= 0 ? previewTranscodeUrl + "&" : previewTranscodeUrl + "?";
        previewTranscodeUrl = previewTranscodeUrl + "size=" + size + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
        img.src = previewTranscodeUrl;
        var imageDim;
        img.onload = (event) => {
          file["height"] = img.height;
          file["width"]= img.width;

          imageDim = this.setPositionForImage(file);
          var dimensions = {
            'imageWidth': imageDim.imageWidth,
            'imageHeight': imageDim.imageHeight
          };

          file["metadata"]["imageHeight"] = imageDim.imageHeight;
          file["metadata"]["imageWidth"] = imageDim.imageWidth;
          var webUrl = this.getImageUrl(dimensions, file);
          file["metadata"]["suggestionPreviewUrl"]= webUrl;
        };
      } else {
        imageDim = this.setPositionForImage(file);
        var dimensions = {
          'imageWidth': imageDim.imageWidth,
          'imageHeight': imageDim.imageHeight
        };
        file["metadata"]["imageHeight"] = imageDim.imageHeight;
        file["metadata"]["imageWidth"] = imageDim.imageWidth;
        var webUrl = this.getImageUrl(dimensions, file);
        file["metadata"]["suggestionPreviewUrl"]= webUrl;
      }
    }
    return file;
  }

  setPositionForImage(file) {
    var orientation = null;
    var rawFile = Object.assign({}, file);
    var availableHeight = 300;
    var availableWidth = $(".actual-img-cont").innerWidth();
    if(availableHeight && availableWidth){
      if(window.innerWidth < 370 || (window.innerWidth > 991 && window.innerWidth < 1281) ){
        this.activeDimensionsSmallMobile["activeHeight"] = 250;
        this.activeDimensionsSmallMobile["activeWidth"] = availableWidth;
      }else{
        this.activeDimensions["activeHeight"] = availableHeight;
        this.activeDimensions["activeWidth"] = availableWidth;
      } 
    }else{
      if(window.innerWidth < 370 || (window.innerWidth > 991 && window.innerWidth < 1281) ){
        availableHeight = 250;
        availableWidth = this.activeDimensionsSmallMobile["activeWidth"];
      }else{
        availableHeight = this.activeDimensions["activeHeight"];
        availableWidth = this.activeDimensions["activeWidth"];
      }
    }

    var imageHeight = undefined;
    var imageWidth = undefined;
    if (!rawFile.inverted && rawFile.orientation != undefined && (rawFile.orientation.indexOf("90") != -1 || rawFile.orientation.indexOf("270") != -1)) {
      file["width"] = rawFile.height;
      file["height"] = rawFile.width;
      rawFile["inverted"] = true;
    }
   
    if (parseInt(file["height"]) > parseInt(file["width"])) { //potrait image
      orientation = "potrait";
      // var ratio = Math.floor(file["height"] / file["width"]);
      var ratio = file["height"] / file["width"];
      if(Math.floor(ratio) > 1){
        ratio = Math.floor(ratio);
      }
      if (file["height"] < availableHeight && file["width"] < availableWidth) {
        imageWidth = file["width"];
        imageHeight = file["height"];
      } else if (file["height"] >= availableHeight) {
        imageHeight = availableHeight;
        imageWidth = imageHeight / ratio;
      }
      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;

      file["metadata"]["top"] = remainingHeight / 2;
      file["metadata"]["left"] = remainingWidth / 2;
    } else {
      orientation = "landscape";
      var ratio = file["width"] / file["height"];
      if (file["width"] < availableWidth && file["height"] < availableHeight) {
        imageWidth = file["width"];
        imageHeight = file["height"];
      } else if (file["height"] > availableHeight) {
        imageHeight = availableHeight;
        imageWidth = imageHeight * ratio;
        if(imageWidth >= availableWidth){
          imageWidth = availableWidth;
          imageHeight = imageWidth / ratio;
        }
      } else {
        imageWidth = availableWidth;
        imageHeight = imageWidth / ratio;
      }

      var remainingWidth = availableWidth - imageWidth;
      var remainingHeight = availableHeight - imageHeight;
      

      file["metadata"]["top"] = remainingHeight / 2;
      file["metadata"]["left"] = remainingWidth / 2;
    }

    return {
      "imageWidth": Math.round(imageWidth),
      "imageHeight": Math.round(imageHeight)
    };
  }


  getImageUrl(dimensions, file) {
    var webUrl = file["metadata"]["image_thumbnail_url"];
    webUrl = webUrl.includes("?") ? webUrl + "&" : webUrl + "?";
    let type = this.universalService.checkIfImgTypeParamIsRequired(file["mimeSubType"]);
    webUrl = webUrl + "size=v&height=" + dimensions.imageHeight * this.displayFactor + "&width=" + dimensions.imageWidth * this.displayFactor + "&apiKey=" + ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
    return webUrl;
  }

  saveSelectedPeopleState(id) {
    this.peopleService.setSelectedPeople(id);
  }

  //when user add/rename the face, update coverpic, we need to reset/get fresh data from api. 
  clearPeopleTabDataInService() {
    this.peopleService.setIsResetRequired(true);
    this.peopleService.setScrollPosition(0); //scroll to top, as updated data comes up on top
  }


  getAllDetectedPlaces(url){
    var self = this;
    this.peopleNextLink = "";
    this.peoplePreviousLink = "";
    return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
            resp=>{
                self.resetDataBeforeSettingRequiredView();
                self.paginationService.spliceAndSaveDataInLocalDB(resp["places"]);
                resp.places.forEach(element => {
                  element["objectName"] = element["placeName"];
                });
                self.fetchNextAndPreviousLinksForPagination(resp);
                self.setRequiredView(self.paginationService.getBufferDataForNextPage(self.currentPageNo));
                self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
                self.universalService.showLoader = false;
                self.loader = false;
                resolve(resp);
            },
            err=>{
                self.universalService.showLoader = false;
                self.loader = false;
                self.isServerError = true;
                self.setContainerHeight();
                reject(err);
            }
        )
    })
  }
  getAllPhotosOfSelectedPlace(url){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(url).subscribe(
          resp=>{
              self.resetDataBeforeSettingRequiredView();
              let type = self.universalService.checkIfImgTypeParamIsRequired("");
              resp.objects.forEach(element => {
                element["imageTranscodeUrl"] = element["thumbnailURL"];
              });
              self.paginationService.spliceAndSaveDataInLocalDB(resp["objects"]);
              self.fetchNextAndPreviousLinksForPagination(resp);
              self.checkPalcesStatus(resp);
              // self.checkFGPStatus(resp);
              
              self.setRequiredView(self.paginationService.getBufferDataForNextPage(self.currentPageNo));
              self.paginationService.deleteLocalBufferOnceThePageIsViewed(self.currentPageNo)
              resolve(resp);
          },
          err=>{
              self.universalService.showLoader = false;
              self.loader = false;
              self.isServerError = true;
              self.setContainerHeight();
              reject(err);
          }
      )
    })
  }
}
